<div class="widget-box {{ color() }}" [class.hover-enabled]="hover()">
  <p class="heading f-body-s">{{ heading() | translate }}</p>

  <div class="content f-paragraph-m f-semibold">
    <ng-content></ng-content>
  </div>
</div>
